import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconShoppingCartComponent } from "./med-icon-shopping-cart.component";

@NgModule({
  declarations: [
    MedIconShoppingCartComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconShoppingCartComponent,
  ],
})
export class MedIconShoppingCartModule { }
